import { Component, Inject, OnInit } from "@angular/core";
import {
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AlertToasterOptions } from "app/class/alert-toaster-options";
import { IUserData } from "app/interfaces/i-userdata";
import { ApiItalyGeoService } from "app/services/api/api-italy-geo.service";
import { LocalStorageService } from "app/services/local-storage/local-storage.service";
import { AlphabeticOnlyValidator } from "app/services/MaterialValidator/AlphabeticOnlyValidator";
import { EmailCustomValidator } from "app/services/MaterialValidator/EmailCustomValidator";
import { NumericOnlyValidator } from "app/services/MaterialValidator/NumericOnlyValidator";
import { assign } from "lodash";
import { Region } from "../../../../../services/api/api-italy-geo.service";
import { GoogleAnalyticsService } from "./../../../../../services/analytics/google-analitics-service";

export const MY_FORMATS = {
    parse: {
        dateInput: "DD/MM/YYYY",
    },
    display: {
        dateInput: "DD/MM/YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY",
    },
};

@Component({
    standalone: false,
    selector: "fuse-dialog-profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.scss"],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class DialogProfileComponent implements OnInit {
    public options = AlertToasterOptions;
    public modalData: IUserData;
    public formGroup: UntypedFormGroup;
    public regions: Region[];
    public gender = [
        { id: "male", name: "Maschio" },
        { id: "female", name: "Femmina" },
    ];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DialogProfileComponent>,
        private httpItalyGeo: ApiItalyGeoService,
        private googleAnalyticsService: GoogleAnalyticsService,
    ) {
        this.httpItalyGeo.getRegions().subscribe((regions) => {
            this.regions = regions;
        });
    }

    ngOnInit(): void {
        this.googleAnalyticsService.pageEmitter("ProfilePage");
        this.modalData = this.data.modalData.userdata as IUserData;
        this.formGroup = new UntypedFormGroup({
            name: new UntypedFormControl(this.modalData.name, [
                Validators.required,
                AlphabeticOnlyValidator.alphabeticOnly,
            ]),
            surname: new UntypedFormControl(this.modalData.surname, [
                Validators.required,
                AlphabeticOnlyValidator.alphabeticOnly,
            ]),
            email: new UntypedFormControl(this.modalData.email, [
                Validators.required,
                EmailCustomValidator.email_custom,
            ]),
            gender: new UntypedFormControl(this.modalData.gender, [
                Validators.required,
            ]),
            phone: new UntypedFormControl(this.modalData.phone, [
                Validators.required,
                NumericOnlyValidator.numericOnly,
            ]),
            id_region: new UntypedFormControl(this.modalData.id_region, [
                Validators.required,
            ]),
        });
    }

    onYesClick(): void {
        const updatedModalData = assign(
            {},
            this.modalData,
            this.formGroup.value,
        );
        delete updatedModalData.privacy_communications;
        delete updatedModalData.privacy_third_part;
        delete updatedModalData.privacyaccept;
        delete updatedModalData.privacy_date_update;
        delete updatedModalData.ip_privacy_declaration;

        this.dialogRef.close(updatedModalData);
    }
}
